// src/pages/Safe.js
import React from "react";
import "../styles/Safe.css";
import { useNavigate } from "react-router-dom";

export default function Safe() {
  const navigate = useNavigate();

  return (
    <div className="safe-page">
      <h1>🚫 Accès restreint</h1>

      <p>
        Cette section est réservée aux administrateurs.
      </p>

      <button onClick={() => navigate("/")}>
        ⬅ Retour à l’accueil
      </button>
    </div>
  );
}
